import { createFileRoute } from '@tanstack/react-router'
import { InvitationTypeList } from '@/components/invitationTypes/InvitationTypeList'

function InvitationTypesPage() {
  return (
    <div className="p-6">
      <InvitationTypeList />
    </div>
  )
}

export const Route = createFileRoute('/invitation-types/')({
  staticData: {
    title: 'Invitation Types',
    isSecured: true,
  },
  component: InvitationTypesPage,
})
